module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "shape-rendering": "geometricPrecision",
      "text-rendering": "geometricPrecision",
      "image-rendering": "optimizeQuality",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M256 0c70.69 0 134.69 28.66 181.02 74.98C483.34 121.3 512 185.31 512 256c0 70.69-28.66 134.69-74.98 181.02C390.69 483.35 326.69 512 256 512c-70.69 0-134.7-28.65-181.02-74.98C28.66 390.69 0 326.69 0 256c0-70.69 28.66-134.7 74.98-181.02C121.3 28.66 185.31 0 256 0zm-89.53 236.97c18 10.36 29.7 18.99 43.61 34.34 36.18-58.19 75.43-90.48 126.48-136.26l4.98-1.91h55.85c-74.89 83.19-132.94 151.75-184.96 252.08-27.05-57.92-51.19-97.84-105.16-134.87l59.2-13.38zm244.92-136.36C371.62 60.85 316.68 36.25 256 36.25c-60.69 0-115.63 24.6-155.39 64.36-39.76 39.77-64.36 94.7-64.36 155.39 0 60.68 24.6 115.62 64.36 155.39 39.76 39.76 94.7 64.36 155.39 64.36 60.68 0 115.62-24.6 155.39-64.36 39.76-39.77 64.36-94.71 64.36-155.39 0-60.69-24.6-115.62-64.36-155.39z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14444f67","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/approvedAcceptSlim.vue
// module id = 5b90716919ac337e502b
// module chunks = 89